import { render, staticRenderFns } from "./car-directory.vue?vue&type=template&id=1b2ccdb6"
import script from "./car-directory.vue?vue&type=script&lang=ts"
export * from "./car-directory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports